import { useEffect, useState } from "react";

export const useClock = (ms = 1000) => {
  const [now, setNow] = useState(Date.now());

  // biome-ignore lint/correctness/useExhaustiveDependencies: Observer
  useEffect(() => {
    const timeout = setTimeout(() => {
      setNow(Date.now());
    }, ms);

    return () => clearTimeout(timeout);
  }, [now]);

  return now;
};
